import axios from "axios";
const {REACT_APP_ACTION_SOCIALE_BY_DLG_CAS_API_URL} = process.env;
const {REACT_APP_MAP_FORM_CLAP_API_URL} = process.env;
const {REACT_APP_MONTANT_TOTAL_PRESTA_API_URL} = process.env

export class ActionSocialeService {
    getActionSocialeDematByCASAndDlg(codeActionSociale, codeDeleg) {
        return axios.get(REACT_APP_ACTION_SOCIALE_BY_DLG_CAS_API_URL+ "?codeDelegation="+codeDeleg + "&codeCas=" +codeActionSociale);
    }

    getMappingFormulaireClap(exercice, codeActionSociale) {
        return axios.get(REACT_APP_MAP_FORM_CLAP_API_URL + "?exercice=" + exercice + "&codeActionSociale=" + codeActionSociale);
    }

    getMontantTotalPrestation(codeCas, dlgId ,exercice) {
            return axios.get(REACT_APP_MONTANT_TOTAL_PRESTA_API_URL + "?dlgId=" + dlgId + "&casCode=" + codeCas+ "&exercice=" + exercice);
    }

    getMontantMinimumDeFrais(codeCas, dlgId ,exercice) {
        return axios.get(REACT_APP_MONTANT_TOTAL_PRESTA_API_URL + "?dlgId=" + dlgId + "&casCode=" + codeCas+ "&exercice=" + exercice);
    }

    persistState(actionSociale) {
        localStorage.setItem("actionSociale", JSON.stringify(actionSociale));
    }
    persistMontantMinFrais(montant) {
            localStorage.setItem("MontantMinFrais", montant);
    }

    getMontantMinFrais() {
           return localStorage.getItem("MontantMinFrais");
    }
}
